import React, { useState, useEffect } from 'react';
import axios from 'axios';
import browserHistory from '../../history';
import Header from '../authentication/Header';
import Footer from '../authentication/Footer';
import Loader from '../Loader';

const getBase = () => (window.site && window.site.screeningApiBaseUrl) || 'https://content-screening-api.dev2.envoi.cloud';
const getApp = () => (window.app && window.app.appName) || 'kyliejenner';
const getUrlApp = () => (window.app && (window.app.urlAppName || window.app.appName)) || 'kyliejenner';
const getEnv = () => (window.app && window.app.appEnvName) || 'dev';
const getToken = () => (window.app && window.app.storage && window.app.storage.getItem('token')) || '';

function getChannelImage(channel) {
  const config = (window.site && window.site.config) || {};
  const cdn = config.sourceCloudFront || '';
  const autoCompress = '?auto=compress,format&width=300';
  const img = channel?.portrait_logo_image || channel?.landscape_logo_image || channel?.thumbnail || '';
  if (!img) return (config.defaultLandscape || '') + autoCompress;
  if (img.startsWith('http')) return img.replace(/ /g, '%20') + autoCompress;
  return (cdn ? cdn + '/' + img.replace(/ /g, '%20') : img.replace(/ /g, '%20')) + autoCompress;
}

function getChannelName(channel) {
  return channel?.channelname || channel?.name || channel?.title || '';
}

function buildUrl(pageNum) {
  const loc = (window.app && window.app.locationData) || {};
  let url = `${getBase()}/getChannels?appname=${getApp()}&env=${getEnv()}&token=${getToken()}&assetcount=12&pageNumber=${pageNum}&scrubbing=true&appType=screening`;
  if (loc.country) url += `&country=${encodeURIComponent(loc.country)}`;
  if (loc.region) url += `&region=${encodeURIComponent(loc.region)}`;
  if (loc.city) url += `&city=${encodeURIComponent(loc.city)}`;
  if (loc.timezone) url += `&timezone=${encodeURIComponent(loc.timezone)}`;
  return url;
}

export default function HeirloomChannelsPage() {
  const [items, setItems] = useState([]);
  const [noOfAssets, setNoOfAssets] = useState(0);
  const [assetTotal, setAssetTotal] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [loadbtn, setLoadbtn] = useState('Load More');

  useEffect(() => {
    axios.get(buildUrl(1))
      .then(res => {
        const result = res.data?.result || {};
        const data = Array.isArray(result.data) ? result.data : (Array.isArray(result) ? result : []);
        const total = result.assetTotal || data.length;
        setItems(data);
        setNoOfAssets(data.length);
        setAssetTotal(total);
      })
      .catch(() => {})
      .finally(() => setIsLoading(false));
  }, []);

  const loadMore = () => {
    const nextPage = pageNumber + 1;
    setLoadbtn('Loading...');
    axios.get(buildUrl(nextPage))
      .then(res => {
        const result = res.data?.result || {};
        const data = Array.isArray(result.data) ? result.data : (Array.isArray(result) ? result : []);
        const total = result.assetTotal || assetTotal;
        setItems(prev => [...prev, ...data]);
        setNoOfAssets(prev => prev + data.length);
        setAssetTotal(total);
        setPageNumber(nextPage);
      })
      .catch(() => {})
      .finally(() => setLoadbtn('Load More'));
  };

  const handleClick = (channel) => {
    const channelCode = channel?.channelcode || channel?.channelCode;
    if (channelCode) {
      browserHistory.push(`/player?appname=${getUrlApp()}&channelCode=${channelCode}`);
    }
  };

  return (
    <React.Fragment>
      <div className="recording_page">
        {isLoading && <Loader />}
        <Header />
        <React.Fragment>
          <div className="enchannel_wrapper minbody-ht" style={{ minHeight: 'calc(100vh - 180px)' }}>

            {!isLoading && items.length > 0 && (
              <div className="page-heading">
                <div className="perpage">
                  <div className="pull-left">{'Results: 1 to ' + noOfAssets + ' of ' + assetTotal}</div>
                </div>
              </div>
            )}

            {!isLoading && items.length > 0 ? (
              <>
                <div className="row">
                  {items.map((channel, i) => (
                    <div className="col-12 col-sm-4 col-md-3 col-lg-2" key={channel._id || channel.channelcode || i}>
                      <div className="channel-card">
                        <div
                          className="channel-thumb"
                          onClick={() => handleClick(channel)}
                          style={{ cursor: 'pointer' }}
                        >
                          <img alt={getChannelName(channel)} src={getChannelImage(channel)} />
                          <a
                            className="publish-btn selected rd_edit"
                            onClick={(e) => { e.stopPropagation(); handleClick(channel); }}
                            style={{ cursor: 'pointer' }}
                            title="info"
                          >
                            <span className="material-symbols-outlined">info</span>
                          </a>
                        </div>
                        <div className="channel-footer">
                          <h5>{getChannelName(channel)}</h5>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {noOfAssets < assetTotal && (
                  <div style={{ textAlign: 'center', clear: 'both' }}>
                    <button
                      onClick={loadMore}
                      style={{
                        padding: '10px 20px',
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                        border: '1px solid rgba(255, 255, 255, 0.2)',
                        borderRadius: '5px',
                        color: '#fff',
                        fontSize: '16px',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                      }}
                      onMouseOver={(e) => {
                        e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
                        e.target.style.borderColor = 'rgba(255, 255, 255, 0.4)';
                      }}
                      onMouseOut={(e) => {
                        e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                        e.target.style.borderColor = 'rgba(255, 255, 255, 0.2)';
                      }}
                    >
                      {loadbtn}
                    </button>
                  </div>
                )}
              </>
            ) : !isLoading ? (
              <div className="warning-wrapper empty-result">
                <img
                  src="https://envoi-common-resources.imgix.net/screening/images/common-images/no-data-found.jpg"
                  className="no-data-found"
                />
                <div className="error-text">
                  <h2 className="text-center">Sorry !</h2>
                  <p>There are no channels available</p>
                </div>
              </div>
            ) : null}

          </div>
        </React.Fragment>
        <Footer />
      </div>
    </React.Fragment>
  );
}
